const React = require('react');
const ReactRedux = require('react-redux');

const moment = require('moment-timezone');

function DeploySchedule(props) {
	if (props.schedule_start) {
		return (
			<div className="deployment-tips col-md-4">
				<i className="fa fa-lg fa-clock-o" aria-hidden="true"></i><h5>This deployment is scheduled</h5>
				<ul className="list-unstyled">
					<li><b>Schedule start</b></li>
					<li>{props.schedule_start ? props.schedule_start.format('DD/MM/YYYY h:mma') + " (" + props.timezone + ")" : "n/a"}</li>
					<li><b>Schedule end</b></li>
					<li>{props.schedule_end ? props.schedule_end.format('DD/MM/YYYY h:mma') + " (" + props.timezone + ")" : "n/a"}</li>
				</ul>
			</div>
		);
	}
	return null;
}

const mapStateToProps = function(state) {
	const current = state.deployment.list[state.deployment.current_id] || {};

	// Times are stored relative to the server's timezone, find the difference between that and the users timezone
	// Use this rather than moment().tz() as this converts from the browsers timezone which may not be the same as the server
	const now = moment().tz(state.user.server_timezone);
	const localOffset = now.utcOffset();
	now.tz(state.user.timezone);
	const centralOffset = now.utcOffset();
	const unix_diff_hours = (localOffset - centralOffset) * 60;

	let schedule_start = null;
	let schedule_end = null;
	if (current.schedule_start_unix) {
		schedule_start = moment.unix(current.schedule_start_unix - unix_diff_hours);
	}
	if (current.schedule_end_unix) {
		schedule_end = moment.unix(current.schedule_end_unix - unix_diff_hours);
	}

	return {
		schedule_start: schedule_start,
		schedule_end: schedule_end,
		timezone: state.user.timezone
	};
};

const mapDispatchToProps = function() {
	return {};
};

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(DeploySchedule);

